var utils = require( './utils' );

var fp_hero = ( function( $ ) {

	var $hero,
		$links,
		$images;

	var _init = function() {
		$hero   = $( '#fp-hero' );
		$links  = $hero.find( 'a.stone-link' );
		$images = $hero.find( 'div.stone-image' );

		$links.on( 'mouseenter', _link_hover );
		$links.on( 'focus', _link_hover );
		$links.on( 'mouseleave', _maybe_show_default_image );
		$links.on( 'focusout', _maybe_show_default_image );
	};

	var _link_hover = function() {
		var $link = $( this );

		_switch_image( $link.data( 'image' ) );
	};

	var _switch_image = function( image_id ) {
		$images.removeClass( 'active' );
		$images.filter( image_id ).addClass( 'active' );
	};

	var _maybe_show_default_image = function() {

		if ( $links.is( ':focus' ) ) {
			return;
		}

		$images.removeClass( 'active' );
		$images.filter( '.default' ).addClass( 'active' );
	};

	if ( $( '#fp-hero' ).length > 0 && utils.viewport_size().width >= 768 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = fp_hero;